module.exports = __webpack_public_path__ + "img/about.1f9efff3.jpg";